import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Box, Button, Typography  } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LoadingCircle from './LoadingCircle';

const BACKEND_URL = process.env.REACT_APP_BACKEND;

export default function InfoPage(data) {
  
  const documentId = data.workshop.documentId;
  const [workshop, setWorkshop] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {

    let isMounted = true;

    const fetchData = async () => {
      try {
        const workshop_response = await axios.get(`${BACKEND_URL}/api/workshops?populate=*&filters[documentId][$eq]=${documentId}`);
        const workshop_data = workshop_response.data.data;

        // console.log(workshop_data);

        const availability_response = await axios.get(`${BACKEND_URL}/api/workshops/${documentId}/available`);
        const availability_data = availability_response.data.data;

        // console.log(availability_data);

        const aggregate_data = { ...workshop_data[0], 'availableSpots': availability_data };

        console.log(aggregate_data);

        if (isMounted) {
          setWorkshop(aggregate_data);
          setLoading(false);
        }

      } catch (err) {
        console.error(err);
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    }

  }, [documentId]);

  if (loading) return <LoadingCircle />;

  return (
    <div>
      <h1>{workshop.name}</h1>
      <p>{workshop.description}</p>
      <Box
        sx={{
          display: "flex",
          height: "100%"
        }}>
        <Typography component={'span'} variant="body2" sx={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          minHeight: '9em', color: 'text.primary', mb: 1.5
        }}>
          <br />
          {workshop.organization}
        </Typography>
      </Box>
      <Box component="img" sx={{ width: {xs: '98%', md: '60%', lg: '50%'}
  }} alt="test" src={`${BACKEND_URL}${workshop.image.url}`}>
      </Box>
    </div>
  );
}
